import React from 'react';
import styled from 'styled-components';
import LoadingIndicatorSVG from '../../../components/loading-indicator';
import FriendlyTestUrl from './FriendlyTestUrl';
import { FlexRow } from '../../performance-scan/components/html';
import { StyledIcon } from '../../pricing-plans/pricing-plan';

function TestRunningText({
  finished, text, mainTestUrl, flags,
}) {
  return (
    <Row center="v">
      <TestDoneWrapper>
        {finished ? <Check withGradient icon="checkmark" /> : <LoadingIndicator />}
      </TestDoneWrapper>

      <FriendlyTestUrl testUrl={text} flags={flags} mainTestUrl={mainTestUrl} />
    </Row>
  );
}

TestRunningText.defaultProps = {
  flags: [],
  mainScanUrl: null,
  finished: false,
  text: '',
};

const LoadingIndicator = styled(LoadingIndicatorSVG)`
  width: 1.25rem;
`;

const TestDoneWrapper = styled.div`
  margin-right: 1rem;
  width: 1.25rem;
`;

const Check = styled(StyledIcon)`
  position: unset;
  font-size: 1.25rem;
`;

const Row = styled(FlexRow)`
margin-bottom: 1rem;
`;

export default TestRunningText;
